/*
 * Loads Vimeo iframes that carry data-vimeo-src only when they come near the viewport.
 * Iframes hidden with display:none (e.g. the desktop/mobile hero duplicate) never intersect, so they never load.
 */
(function () {
  if (window.__vimeoLazyInit) return;
  window.__vimeoLazyInit = true;

  function load(frame) {
    var src = frame.getAttribute('data-vimeo-src');
    if (!src) return;
    frame.setAttribute('src', src);
    frame.removeAttribute('data-vimeo-src');
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              load(entry.target);
            });
          },
          { rootMargin: '300px' }
        )
      : null;

  function scan(root) {
    (root || document).querySelectorAll('iframe[data-vimeo-src]').forEach(function (frame) {
      if (observer) observer.observe(frame);
      else load(frame);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
